// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__Z32aI","logo":"footer_logo__3Ar7O","right":"footer_right__VDRRJ"};